import { getIam, postApv, postIam } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  decodeJWT,
  deserialize,
  getBankModalLayer,
  getIframe,
  serialize,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  setNumericOnly,
  stringToHTML,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setAlertModal, showAlertModal } from '../components/alert';

const AccountRegi = {
  render: async () => {
    return `
      <div>
        <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="c_title1">계좌 등록 </div>
      <div class="form-group m_b_20">
          <label class="c_label1">계좌번호</label>
          <div class="c_bod1 c_box skin1_bod" id="bank_select">
              <input type="hidden" id="bank_cd" name="bank_cd" />
              <div id="bank_nm" class="c_label4_3">은행</div>
              <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
          </div>
          <div class="m_t_10 m_b_50">
              <input id="accno" type="text" class="form-control c_input1 skin1_input" placeholder="계좌번호" pattern="[0-9]*" inputmode="numeric">
          </div>
          <div id="account_termsList">

          </div>
         
      </div>
      <div class="bottom_btn_wrapper">
          <button id="account_reg_next" class="btn c_btn1 skin1_btn">다음</button>
      </div>
    `;
  },
  afterRender: async () => {
    let account_termsList = [];
    let account_termsListHTML = '';

    setAlertModal();
    setNumericOnly('accno');

    try {
      const bankModalLayer = await getBankModalLayer();
      stringToHTML(bankModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e, () => history.back());
    }

    const isCheckedAll = (type) => {
      let checkedAll = true;
      let checkedMandtAll = true;

      account_termsList.forEach((term, i) => {
        checkedAll =
          checkedAll && getIframe().getElementById(`terms_${i}`).checked;

        if (type === 'mandatory' && term.mandtYn === 'N') return false;
        checkedMandtAll =
          checkedMandtAll && getIframe().getElementById(`terms_${i}`).checked;
      });

      return type === 'all' ? checkedAll : checkedMandtAll;
    };

    const callTerms = async (bankCd) => {
      account_termsList = [];
      account_termsListHTML = '';

      try {
        const termsRes = await getIam(`accountRegTerms?bankCd=${bankCd}`);
        account_termsList = termsRes.resultData.termsInf;
      } catch (e) {
        showAlertModal('오류', e.resultMessage || e);
        console.error(e.resultMessage || e);
      }

      account_termsList.forEach((term, index) => {
        const termsPath = `${SDK_DOMAIN}/terms/${term.termsFileName}`;

        account_termsListHTML += `
            <div class="form-check m_l_5 m_r_5 m_b_20 c_box">
            <input class="form-check-input custom-control-input skin1_check" type="checkbox" value="" id="terms_${index}">
            <label class="form-check-label custom-control-label skin1_check_label c_label4" for="terms_${index}">&nbsp;${
          term.termsKndName
        } ${term.mandtYn === 'Y' ? '(필수)' : '(선택)'}</label>
        <img src="${SDK_DOMAIN}/images/icon_more.svg" value="${serialize({
          termsKndName: term.termsKndName,
          termsPath,
          termIdx: index,
        })}" />
      </div>
      <div style="display: none" id="terms_view_${index}">
         <iframe  style="border-width: 0px; width: 100%;" src="${termsPath}"></iframe>
        </div>
        `;
      });

      setIframeInnerHtml('account_termsList', account_termsListHTML);

      function showTerms(idx) {
        let openYn = getIframe().getElementById('terms_view_' + idx).style
          .display;
        if (openYn == 'block') {
          getIframe().getElementById('terms_view_' + idx).style.display =
            'none';
        } else {
          getIframe().getElementById('terms_view_' + idx).style.display =
            'block';
        }
      }

      getIframe()
        .querySelectorAll('#account_termsList > div > img')
        .forEach((element) => {
          const termsInfo = deserialize(element.getAttribute('value'));
          element.addEventListener('click', () => {
            showTerms(termsInfo.termIdx);

            //  console.log(termsInfo)
            // var options =
            //   'top=100, left=0, width=450, height=900,scrollbars=no';
            // window.open(termsInfo.termsPath, termsInfo.termsKndName, options);

            // pushRouter(
            //   {
            //     termsKndName: termsInfo.termsKndName,
            //     termsPath: termsInfo.termsPath,
            //   },
            //   null,
            //   routes.termsView.hashPath
            // );
          });
        });
    };

    const handleBankChanged = async (bankInfoStr) => {
      const bankInfo = deserialize(bankInfoStr);

      getIframe().getElementById('bank_cd').value = bankInfo.bankCd;
      getIframe().getElementById('bank_nm').textContent = bankInfo.bankNm;
      callTerms(bankInfo.bankCd);
      closeBottomSheet('bank_select');
    };

    setAddEventListener('account_reg_next', async () => {
      if (!isCheckedAll('mandatory')) {
        showAlertModal('알림', '필수약관에 동의해주세요.');
        return;
      }

      if (getIframe().getElementById('bank_cd').value.trim() == '') {
        showAlertModal('알림', '은행을 선택해주세요.');
        return;
      }
      if (getIframe().getElementById('accno').value.trim() == '') {
        showAlertModal('알림', '계좌번호를 입력해주세요.');
        return;
      }

      const userNm = decodeJWT().nm;
      const bankCd = getIframe().getElementById('bank_cd').value.trim();
      const accno = getIframe().getElementById('accno').value.trim();

      try {
        // 계좌 실명 인증
        const acctNameData = {
          bankCd,
          searchAcctNo: accno,
        };
        const acctNameResult = await postApv(
          'common/getAcctName',
          acctNameData
        );
        const accOwnerName = acctNameResult.accOwnerName;

        // 쿠콘 실명인증 API 개발의 경우, 실예금주명 넘어오지 않음
        if (process.env.NODE_ENV == 'production' && accOwnerName != userNm) {
          showAlertModal('알림', '본인 계좌만 등록 가능합니다.');
          return;
        }

        // 1원인증 요청
        const accountChkData = {
          membNm: userNm,
          acctNo: accno,
          bankCd,
        };
        const accountChkResult = await postApv(
          'common/accountChk',
          accountChkData
        );

        const state = {
          verifyTrDt: accountChkResult.verifyTrDt,
          verifyTrNo: accountChkResult.verifyTrNo,
          bankCd,
          acctNo: accno,
          membNm: userNm,
        };

        // 1원인증 화면 이동
        pushRouter(state, null, routes.accountAuth.hashPath);
      } catch (e) {
        showAlertModal('오류', e.resultMessage);
        console.error(e);
      }
    });

    getIframe()
      .querySelectorAll('#bank_list > div > img')
      .forEach((element) =>
        element.addEventListener('click', () => {
          handleBankChanged(element.getAttribute('value'));
        })
      );
    setAddEventListener('connect_pay_back_button', () => history.back());
    setBottomSheet('bank_select');
  },
};
export default AccountRegi;
